export default {
      id: "update-life-certificate-usage",
      viewBox: "0 0 35 32",
      url: __webpack_public_path__ + "sprite.svg#update-life-certificate",
      toString: function () {
        return this.url;
      }
    }